import Badge from '@anm/components/Badge';
import Tooltip from '@anm/components/Tooltip';
import { flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const StreamStatusBadge = styled(Badge)`
  min-width: max-content;
`;

export const ExtraBadge = styled(StreamStatusBadge)`
  margin-left: -10px;
`;

export const ErrorTooltip = styled(Tooltip)`
  min-width: 200px;
  padding: 12px 16px;
  transform: translate(25%, calc(-100% - 10px));
  &:before {
    left: 49%;
  }
`;

export const TooltipText = styled.span`
  color: #fff;
  font-size: 14px;
  span {
    color: #30aef2;
    cursor: pointer;
  }
`;

const wrapperOnMobile = media.phone`
  flex: 1;
`;

export const Wrapper = styled.div`
  ${flexRow};
  margin: 0;
  & > * {
    margin-right: 16px;
  }

  ${wrapperOnMobile};
`;
